<template>
  <button class="button is-small has-light-border" :class="{'is-loading':isLoading}" type="button" @click.prevent="refresh">
    <b-icon v-if="icon" :icon="icon" custom-size="default"></b-icon>
    <span v-if="label">{{ label }}</span>
  </button>
</template>

<script>
  export default {
    name: "RefreshButton",
    props: {
      icon: {
        type: String,
        default: 'refresh'
      },
      label: {
        type: String,
        default: null,
      },
      isLoading: {
        type: Boolean,
        default: false,
      }
    },
    methods: {
      refresh() {
        this.$emit('refresh')
      }
    }
  }
</script>

<style scoped>

</style>